import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function OrdinalsOmega({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" id="&#206;&#169;" d="M0.526123 12V10.2023H2.82092V10.1098C1.41052 9.19653 0.526123 7.7052 0.526123 5.63584C0.526123 2.33526 2.7978 0 6.00011 0C9.20242 0 11.4741 2.33526 11.4741 5.63584C11.4741 7.7052 10.5897 9.19653 9.1793 10.1098V10.2023H11.4741V12H6.94231V9.7341C8.28335 9.17919 9.32959 7.65318 9.32959 5.76879C9.32959 3.58959 7.95387 1.93064 6.00011 1.93064C4.05213 1.93064 2.67063 3.58959 2.67063 5.76879C2.67063 7.65318 3.71687 9.17919 5.05792 9.7341V12H0.526123Z" fill="currentColor" /></Svg>;
}
export default OrdinalsOmega;